<template>
    <sa-page-layout :showModalLoading="showModalLoading" class="sa-no-space" btnRefreshVisible @refresh="refresh">
        <template slot="table-filter">
            <b-form style="width: 100%" @submit.prevent="submit">
                <div class="sa-form-section sa-search-box m-2">
                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="sa-form-btn-filter">
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Data Dal:</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoPratiche.dataDal" format="DD-MM-YYYY" value-type="timestamp" type="date" @change="onDataDalChange"></date-picker>
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Data Al:</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoPratiche.dataAl" format="DD-MM-YYYY" value-type="timestamp" type="date" :disabled-date="isDataAlDisabled"></date-picker>
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Cognome Assistito:</label>
                            <input class="sa-search-box-input text-upper" type="search" v-model="filtroRiepilogoPratiche.cognomeAssistito" placeholder="Inserisci un cognome..." />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
                            <label class="sa-label-data">Nome Assistito:</label>
                            <input class="sa-search-box-input text-upper" type="search" v-model="filtroRiepilogoPratiche.nomeAssistito" placeholder="Inserisci un nome..." />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                            <label class="sa-label-data">Stato Pratica:</label>
                            <b-form-select v-model="filtroRiepilogoPratiche.stato" class="sa-ft-form-select">
                                <b-form-select-option :value="null"> TUTTI </b-form-select-option>
                                <b-form-select-option v-for="(stato, i) in statiOptions" :key="i" :value="stato">
                                    {{ stato }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                            <label class="sa-label-data">Intervento:</label>
                            <input class="sa-search-box-input text-upper" type="search" v-model="filtroRiepilogoPratiche.tipoPrestazioneDescrizione" placeholder="Inserisci un intervetno..." />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                            <label class="sa-label-data">Stato Intervento</label>
                            <b-form-select v-model="filtroRiepilogoPratiche.statoIntervento" class="sa-ft-form-select">
                                <b-form-select-option :value="null"> TUTTI </b-form-select-option>
                                <b-form-select-option value="PROGRAMMATO"> PROGRAMMATO </b-form-select-option>
                                <b-form-select-option value="ESEGUITO"> ESEGUITO </b-form-select-option>
                                <b-form-select-option value="RENDICONTATO"> RENDICONTATO </b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <!-- <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
							<div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
								<label class="sa-search-box-label">Data Riferimento Prenotazione</label>
							
							</div>
						</b-col> -->
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="padding: 8px; gap: 10px; display: flex; justify-content: end">
                            <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                            <b-button type="button" @click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-form>
        </template>
        <template slot="table-body">
            <SiatRiepilogoPraticheListComponent @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" ref="cmpSiatRiepilogoPraticheListComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin.js";
import SiatRiepilogoPraticheListComponent from "../components/SiatRiepilogoPraticheListComponent.vue";
import DatePicker from "vue2-datepicker";

export default {
    components: { SaPageLayout, SiatRiepilogoPraticheListComponent, DatePicker },
    mixins: [UtilityMixin],
    data() {
        let dataDal = new Date().setHours(0, 0, 0, 0);
        let dataAl = new Date().setHours(23, 59, 59, 999);

        return {
            statiOptions: ["APERTA"],
            showModalLoading: false,
            filtroRiepilogoPratiche: {
                cognomeAssistito: null,
                nomeAssistito: null,
                dataDal,
                dataAl,
                stato: "APERTA",
                tipoPrestazioneDescrizione: "",
                statoIntervento: "",
            },
            notificheNumber: 0,
        };
    },
    mounted() {
        let sessionStorage = window.sessionStorage;
        // let filter = {
        //     forPage: this.perPage,
        //     page: this.currentPage,
        // };
        if (sessionStorage["filtroRiepilogoPratiche"]) {
            this.filtroRiepilogoPratiche = JSON.parse(sessionStorage["filtroRiepilogoPratiche"]);
            // filter = { ...filter, ...filtro };
        }
        this.submit();
    },

    methods: {
        loadData() {
            if (this.$refs.cmpSiatRiepilogoPraticheListComponent) {
                this.$refs.cmpSiatRiepilogoPraticheListComponent.loadData();
            }
        },
        refresh() {
            this.loadData();
        },
        isDataAlDisabled(date) {
            if (!this.filtroRiepilogoPratiche.dataDal) {
                return false;
            }
            let dataDal = new Date(this.filtroRiepilogoPratiche.dataDal);
            dataDal.setHours(0, 0, 0, 0);
            return date.getTime() < dataDal.getTime();
        },
        onDataDalChange(dataDal) {
            let dataAl = this.filtroRiepilogoPratiche.dataAl;
            if (dataDal && dataAl && dataAl < dataDal) {
                this.filtroRiepilogoPratiche.dataAl = new Date(dataDal).setHours(23, 59, 59, 999);
            }
        },
        onReset() {
            let dataDal = new Date().setHours(0, 0, 0, 0);
            let dataAl = new Date().setHours(23, 59, 59, 999);

            this.filtroRiepilogoPratiche = {
                cognomeAssistito: null,
                nomeAssistito: null,
                dataDal: dataDal,
                dataAl: dataAl,
                stato: "APERTA",
                tipoPrestazioneDescrizione: "",
                statoIntervento: "",
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoPratiche"] = JSON.stringify(this.filtroRiepilogoPratiche);
            this.loadData();
        },
        submit() {
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoPratiche"] = JSON.stringify(this.filtroRiepilogoPratiche);
            this.loadData();
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
    },
};
</script>
<style scoped>
.sa-search-box-input.text-upper::placeholder {
    text-transform: lowercase;
}
</style>
